import 'maplibre-gl/dist/maplibre-gl.css';

import './css/index.scss';

import { Map } from './Map';

import * as Utils from './utils';

import { Popup } from 'maplibre-gl';

import {
  VERSION,
  VERSION_INFO,
  getVersion,
  getVersionInfo,
  compareVersions,
  assertMinVersion,
} from './Version';

import { computeScaleBarSnapshot } from './Controls/scaleBarCompute';

export {
  Map,
  Popup,
  Utils,
  computeScaleBarSnapshot,
  VERSION,
  VERSION_INFO,
  getVersion,
  getVersionInfo,
  compareVersions,
  assertMinVersion,
};

export {
  MapModelsManager,
  createDefaultPlacedModel,
  createPlacedModelId,
  normalizeMapModelsDocument,
  toMapModelsDocument,
  MAP_MODELS_SOURCE_ID,
  MAP_MODELS_LAYER_ID,
  MAP_MODELS_SELECTED_LAYER_ID,
  MAP_MODELS_CUSTOM_LAYER_ID,
} from './Models3D';

export type {
  MapPlacedModel,
  MapPlacedModelPayload,
  MapModelsDocument,
} from './Models3D';

export const version = VERSION;

function logGeoboxGlVersion(): void {
  if (typeof console === 'undefined' || typeof console.info !== 'function') {
    return;
  }

  const commit = VERSION_INFO.gitCommit ? ` (${VERSION_INFO.gitCommit})` : '';
  console.info(
    `%c geobox-gl %c v${VERSION}${commit} `,
    'background:#2563eb;color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold',
    'color:inherit;font-weight:normal',
    VERSION_INFO,
  );
}

logGeoboxGlVersion();

export type {

  MeasurementOptions,

  MeasurementCursorPayload,

  MeasurementGeometryPayload,

  MeasurementGeometryVertex,

  customBasemap,

} from './Types';

export type {

  EditGeometryOptions,

  EditGeometryCursorPayload,

  EditGeometryPayload,

  EditGeometryVertex,

  EditGeometryContext,

} from './Controls/editGeometryCompute';

export {

  buildEditGeometryPayload,

  verticesFromFeature,

  applyVertexLngLatToFeature,

  isDrawSketchMode,

  isEditSelectMode,

} from './Controls/editGeometryCompute';

export {
  DEFAULT_FEATURE_GEOMETRY_SRID,
  GEOBOX_API_GEOMETRY_SRID,
  positionToLngLat,
  geometryToLngLat,
  normalizeSketchFeatureToWgs84,
  normalizeDrawFeatureCollectionToWgs84,
  featureGeometryForDraw,
  prepareSketchFeatureForCreate,
} from './Controls/featureCreateGeometry';

export type {

  ScaleBarHostUnit,

  ScaleBarSnapshot,

  ScaleBarHostOptions,

  ComputeScaleBarOptions,

} from './Controls/scaleBarCompute';

export type {
  MiniMapHostOptions,
  MiniMapHostState,
} from './Controls/miniMapHost';

